import { FC, ReactNode, useState } from 'react'

import { AntTooltip, defaultTheme, Icons, Progress } from '@agro-club/agroclub-shared'

import styled from 'styled-components'
import { FilesContent, FilesHeader, FilesStyled } from 'views/components/FilesByTypes/styled'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import { AButton } from 'views/components/Analytics'
import { AddDriverDocModal } from './AddDriverDocModal'
import { refetchFunc } from 'modules/domain/common/hooks'

const ButtonWrapper = styled.div`
  display: flex;
  column-gap: 8px;
`

const IconQuestionWrapper = styled.div`
  width: 24px;
  height: 24px;
  margin-left: 4px;

  svg > path {
    fill: ${defaultTheme.color.secondary300};
  }

  &:hover > svg > path {
    fill: ${defaultTheme.color.secondary900};
  }
`

interface Props {
  header: string
  allowAdd?: boolean
  progress?: Progress
  refetch: refetchFunc
  description?: ReactNode
  children?: React.ReactNode
  uploadUrl: string
  documentType: string
  maxWidth?: number
}

// it is used in Drive only for now, if it will used in other places, we need to pass ModalComponent as prop, hardcoded for now
const FilesGroupModal: FC<Props> = ({
  header,
  refetch,
  children,
  allowAdd = true,
  progress,
  description,
  uploadUrl,
  documentType,
  maxWidth,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <FilesStyled>
      <FilesHeader>
        <AntTooltip
          overlayStyle={{ maxWidth: maxWidth ? maxWidth - 50 + 'px' : '300px' }}
          placement="top"
          variant="secondary"
          tooltipContent={header}
        >
          <TruncatedValue hint={header}>{header}</TruncatedValue>
        </AntTooltip>

        {allowAdd && (
          <ButtonWrapper>
            {description && (
              <AntTooltip
                variant="secondary"
                tooltipContent={description}
                overlayInnerStyle={{ width: 300 }}
                arrowPointAtCenter
                placement="topLeft"
              >
                <IconQuestionWrapper>
                  <Icons.IconHow />
                </IconQuestionWrapper>
              </AntTooltip>
            )}

            <AButton
              id="addFile"
              progress={progress}
              color="approve"
              Icon={Icons.IconAdd}
              size="small"
              onClick={() => setIsModalOpen(true)}
            />
          </ButtonWrapper>
        )}
      </FilesHeader>
      {children && <FilesContent>{children}</FilesContent>}
      {isModalOpen && (
        <AddDriverDocModal
          refetch={refetch}
          onClose={() => setIsModalOpen(false)}
          documentType={documentType}
          uploadUrl={uploadUrl}
        />
      )}
    </FilesStyled>
  )
}

export default FilesGroupModal
